import { HttpErrorResponse } from '@angular/common/http';
import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';

/**
 * Filter shape of the test-plans overview, serialized into `SavedView.filtersJson` (NEX-787).
 *
 * `version` bleibt als Feld erhalten, obwohl der Version-Chip mit NEX-1059 entfallen ist:
 * Alt-Ansichten in Produktion tragen einen version-Wert, der beim Laden in die
 * Suche gespiegelt wird (siehe `TestPlansComponent.onSavedViewSelected`). Wuerden
 * wir das Feld hier entfernen, wuerde `JSON.parse` den Wert stumm verwerfen und
 * die Migration ins Leere laufen. Auf der Schreibseite ist `version` immer `null`.
 */
export interface TestPlanSavedViewFilters {
  query: string | null;
  version: string | null;
  assignee: string | null;
}

const EMPTY_TEST_PLAN_SAVED_VIEW_FILTERS: TestPlanSavedViewFilters = {
  query: null,
  version: null,
  assignee: null,
};

export function parseTestPlanSavedViewFilters(filtersJson: string | null): TestPlanSavedViewFilters {
  return parseSavedViewFilters(filtersJson, EMPTY_TEST_PLAN_SAVED_VIEW_FILTERS);
}

export function buildTestPlanSavedViewFiltersJson(filters: TestPlanSavedViewFilters): string {
  return buildSavedViewFiltersJson(filters);
}

export function writeErrorKey(error: unknown, fallbackKey: string): string {
  return error instanceof HttpErrorResponse && error.status === 403 ? 'testPlans.forbidden' : fallbackKey;
}
